<template>
  <div id="app">
    <Chatbot />
  </div>
</template>

<script>
import Chatbot from '@/components/Chatbot.vue'

export default {
  components: {
    Chatbot
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deepseek/index.vue